import styles from "../../assets/styles/ExchangeRate/ExchangeRate.module.scss";
import React, { useState } from "react";
import {
  AppPage,
  MimaButton,
  MimaFilter,
  PageLoader,
  Searchbar,
} from "../../components";
import { AnimatePresence } from "framer-motion";
import { ChangeRateContainer } from "../../containers";
import moment from "moment";

const ExchangeRate = ({
  exchangeRates,
  loading,
  rateModal,
  goToRateModal,
  closeModal,
}) => {
  const [filteredExchangeItems, setFilteredExchangeItems] = useState([]);

  const exchangeItems = exchangeRates.exchangeRates;

  return (
    <AppPage pageTitle="Exchange Rate">
      {loading ? (
        <PageLoader title="while we load your information" />
      ) : (
        <>
          <div className={styles.searchInMiddle}>
            <Searchbar
              placeholder="Search"
              input={exchangeItems}
              output={setFilteredExchangeItems}
              handleFilter={(item, searchQuery) => {
                return (
                  item?.status.toLowerCase()?.includes(searchQuery) ||
                  item?.type.toLowerCase()?.includes(searchQuery) ||
                  item?.fromCurrency.toLowerCase()?.includes(searchQuery) ||
                  item?.toCurrency.toLowerCase()?.includes(searchQuery)
                );
              }}
            />
            <MimaButton
              buttonColor="var(--color-white)"
              variant="outlined"
              title="Change Rate"
              onClick={goToRateModal}
            />
          </div>
          <div className="whiteTable">
            <table>
              <thead>
                <tr>
                  <th>Currency From</th>
                  <th>Currency To</th>
                  <th>Rate</th>
                  <th>Money-Ex Rate</th>
                  <th>Max Market Rate</th>
                  <th>Min Market Rate</th>
                  <th>Type</th>
                  <th>Rate For:</th>

                  <th>
                    {" "}
                    <div className="status__th">Status</div>{" "}
                  </th>
                  <th>Date Modified</th>
                </tr>
              </thead>
              <tbody>
                {filteredExchangeItems.map((item) => (
                  <tr key={item._id}>
                    <td>{item.fromCurrency}</td>
                    <td>{item.toCurrency}</td>
                    <td>{item.ngnRate}</td>
                    <td>{item.moneyExRate}</td>
                    <td>{item.maxMarketRate}</td>
                    <td>{item.minMarketRate}</td>
                    <td>{item.type}</td>
                    <td>
                      {item.businesses.length > 0 ? (
                        <>
                          {item.businesses.map(
                            (business) => {
                              return (
                                <div key={business._id}>{business.tradingName}</div>
                              )
                            }
                          )}
                        </>
                      ) : (
                        "General"
                      )}
                    </td>
                    <td>
                      <div
                        className={`status ${
                          item?.status === "ACTIVE"
                            ? "status__green"
                            : item.status === "INACTIVE"
                              ? "status__red"
                              : "status__dark__yellow"
                        }`}
                      >
                        {item?.status}
                      </div>
                    </td>
                    <td>
                      {moment(item.updatedAt).format("DD/MM/YYYY HH:mm a")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {rateModal && (
            <div className="modal">
              <AnimatePresence>
                {rateModal && (
                  <ChangeRateContainer
                    rateModal={rateModal}
                    closeModal={closeModal}
                  />
                )}
              </AnimatePresence>
            </div>
          )}
        </>
      )}
    </AppPage>
  );
};
export default ExchangeRate;
